import { render, staticRenderFns } from "./bar-loader.vue?vue&type=template&id=fac1cdf8&scoped=true&"
import script from "./bar-loader.vue?vue&type=script&lang=js&"
export * from "./bar-loader.vue?vue&type=script&lang=js&"
import style0 from "./bar-loader.vue?vue&type=style&index=0&id=fac1cdf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac1cdf8",
  null
  
)

export default component.exports